const es = {
    "sc_title": "Centro de seguridad",
    "sc_subtitle": "Capa de seguridad integrada GaiaShield",
    "sc_tab_status": "🛡️ Estado de protección",
    "sc_tab_events": "📋 Log de seguridad",
    "sc_tab_node": "⚙️ Seguridad del nodo",
    "sc_loading": "Cargando datos de seguridad...",
    "sc_status_secured": "Estado del sistema: Cuenta protegida",
    "sc_status_warning": "Estado del sistema: Advertencias activas",
    "sc_desc_secured": "No hay advertencias de seguridad críticas activas. GaiaShield está monitoreando activamente su cuenta.",
    "sc_desc_warning": "Atención: Hay eventos de seguridad activos que requieren su atención.",
    "sc_account_protection": "Protección de cuenta",
    "sc_message_protection": "Protección de mensajes",
    "sc_audits": "Auditorías de seguridad",
    "sc_active": "ACTIVO",
    "sc_failed_logins": "Inicios de sesión fallidos",
    "sc_tamper_checks": "Pruebas de manipulación",
    "sc_blocked_replays": "Replays bloqueados",
    "sc_last_check": "Última comprobación",
    "sc_just_now": "Justo ahora",
    "sc_open_warnings": "Advertencias abiertas",
    "sc_btn_acknowledge": "Confirmar",
    "sc_filter_severity": "Gravedad",
    "sc_filter_category": "Categoría",
    "sc_filter_hide_ack": "Ocultar confirmados",
    "sc_btn_export": "Exportar",
    "sc_col_details": "Detalles",
    "sc_col_time": "Hora",
    "sc_col_status": "Estado",
    "sc_col_action": "Acción",
    "sc_no_events": "No se encontraron eventos de seguridad.",
    "sc_node_title": "Consola de seguridad del operador de nodo",
    "sc_system_health": "Salud del sistema",
    "sc_last_audit": "Última auditoría",
    "sc_packed_logs": "Logs empaquetados",
    "sc_unconfirmed_events": "Eventos no confirmados",
    "sc_operator_action": "Acción del operador requerida",
    "sc_all_ok": "Todo correcto",
    "sc_critical_events": "Eventos críticos del sistema",
    "ac_title": "Centro de gobernanza y denuncias",
    "ac_subtitle": "Consenso de gobernanza y abuso de GaiaCom",
    "ac_tab_my_reports": "Mis denuncias",
    "ac_tab_queue": "Cola de revisión",
    "ac_tab_operator": "Operador de nodo",
    "ac_tab_transparency": "Federación y transparencia",
    "ac_loading": "Cargando datos...",
    "ac_reported_cases": "Casos denunciados",
    "ac_no_reports": "Aún no ha enviado ninguna denuncia.",
    "ac_case_details": "Detalles del caso",
    "ac_appeal_submit": "Presentar apelación",
    "ac_appeal_status": "Estado de la apelación",
    "ac_appeal_reason": "Motivo de la apelación",
    "ac_appeal_statement": "Declaración",
    "ac_btn_appeal": "Enviar apelación",
    "ac_trusted_reviewer_queue": "Cola de revisores de confianza",
    "ac_case_review": "Revisar caso",
    "ac_review_category": "Categoría recomendada",
    "ac_review_severity": "Gravedad recomendada",
    "ac_review_action": "Acción recomendada",
    "ac_review_reason": "Motivo del revisor",
    "ac_btn_submit_review": "Enviar revisión",
    "ac_node_operator_dashboard": "Tablero del operador de nodo",
    "ac_apply_action": "Aplicar acción (Override)",
    "ac_target_type": "Tipo de objetivo",
    "ac_target_id": "ID del objetivo (GaiaID o ID del canal)",
    "ac_suspend": "Suspensión activa",
    "ac_reason": "Motivo oficial",
    "ac_btn_apply": "Forzar acción",
    "ac_transparency_title": "Registro de consenso y transparencia",
    "ac_transparency_desc": "Pruebas de instantáneas visibles públicamente de todos los canales e identidades moderados.",
    "ac_btn_snapshot": "Crear instantánea de transparencia",
    "search_placeholder": "Buscar correos por asunto, remitente, texto...",
    "abuse_center_title": "Centro de abuso",
    "abbrechen": "Cancelar",
    "active_identities": "Identidades Activas",
    "active_identity": "Identidad Activa",
    "add_btn": "Agregar",
    "add_contact_title": "Añadir contacto",
    "admin": "Administrador",
    "adressbuch": "Libreta de Direcciones",
    "aktiviert": "Activado",
    "an": "Para",
    "anonymous_sender": "Remitente Anónimo",
    "antworten": "Responder",
    "attachment_gaia_hint": "Los archivos adjuntos de GaiaCOM permanecen cifrados de extremo a extremo.",
    "attachment_smtp_hint": "SMTP heredado bloquea archivos adjuntos ejecutables/tipo script y guarda los correos electrónicos como inseguros.",
    "attachments": "Adjuntos",
    "auffaellig": "Llamativo",
    "auth_beta_notice": "Fase beta: GaiaCOM se está probando activamente. Pueden aparecer errores; guarda tus seeds importantes y verifica con cuidado los flujos sensibles.",
    "auth_btn_login": "Cargar Identidad e Iniciar Sesión",
    "auth_btn_register": "Registrarse y Crear Cripto",
    "auth_copied": "Copiado",
    "auth_copy_seed": "Copiar semilla",
    "auth_generate_seed": "Generar semilla",
    "auth_headline": "GaiaCOM es el primer protocolo de correo electrónico y sistema de comunicación seguro frente a la computación cuántica, creado para la humanidad.",
    "auth_kicker": "Comunicación segura poscuántica",
    "auth_mnemonic": "Frase mnemónica",
    "auth_mnemonic_placeholder": "12 palabras separadas por espacios...",
    "auth_password": "Contraseña",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Las claves privadas nunca salen de su dispositivo. Solo los destinatarios previstos pueden descifrar el contenido.",
    "auth_proof_gaiadata_desc": "Zero-Knowledge: usted mantiene el control de sus datos. Los metadatos se minimizan y no se convierten en un perfil en texto claro.",
    "auth_proof_gaiadrop_desc": "Personas externas pueden enviar avisos de texto confidenciales a su GaiaID sin tener una cuenta.",
    "auth_proof_gaiaproof_desc": "Las pruebas de entrega e integridad muestran que el texto cifrado, el remitente y la marca temporal no fueron manipulados.",
    "auth_proof_gaiavault_desc": "Las notas privadas, las pistas de recuperación y los registros de seguridad permanecen cifrados localmente.",
    "auth_proof_hybrid_desc": "Quantum Shield: el cifrado híbrido con ML-KEM y X25519 protege frente a ataques actuales y al riesgo de guardar ahora y descifrar después.",
    "auth_secure_mail": "Correo Federado Cuántico Seguro",
    "auth_subline": "GaiaCOM es un sistema de comunicación resistente a la computación cuántica para correo, chat, salas de crisis, GaiaDrop y registros locales de seguridad. Las claves privadas permanecen en su dispositivo, el contenido se cifra de extremo a extremo y las pruebas pueden exportarse sin revelar texto claro.",
    "auth_success_btn": "Iniciar Sesión Ahora",
    "auth_success_text": "Su cuenta de GaiaCOM ha sido creada. Las claves se derivaron localmente de su semilla y no se almacenaron en el servidor.",
    "auth_success_title": "Registro Exitoso",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Inicio de sesión / cuenta",
    "auth_toggle_login": "Ya tengo una cuenta",
    "auth_toggle_register": "Crear nueva cuenta",
    "auth_usecase_text": "Diseñado para abogados, empresas, organismos, periodistas, informantes y casos privados de seguridad.",
    "auth_usecase_title": "Creado para comunicación sensible",
    "auth_username": "Nombre de usuario",
    "auth_username_placeholder": "Ingrese el nombre...",
    "auth_value_chat": "Chat E2E",
    "auth_value_drop": "Secure Drop",
    "auth_value_mail": "Correo seguro",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "Confirmar",
    "bestaetigt": "Confirmado",
    "bio_status": "Biografía / Estado",
    "biography": "Biografía",
    "change_password_desc": "Cambia tu contraseña de inicio de sesión en el servidor. Tu frase de recuperación local permanece guardada por separado protegida por tu contraseña de Vault/Unlock.",
    "change_password_menu_desc": "Actualice la contraseña de inicio de sesión de GaiaCOM.",
    "change_password_title": "Cambiar Contraseña",
    "channel_id": "ID de canal",
    "channel_name_label": "Nombre del canal",
    "chat_deleted_hidden": "Chat eliminado y oculto.",
    "chat_input_placeholder": "Introduce mensaje seguro...",
    "chat_start_hint": "¡Comienza la conversación! Todos los mensajes de chat están cifrados E2E de forma cuántica segura.",
    "choose_avatar": "Elegir Avatar",
    "ciphertext_hash": "Hash del texto cifrado",
    "clear_chat": "charla vacía",
    "clear_for_everyone": "Vacio para todos",
    "clear_for_me": "Vacio solo para mi",
    "click_to_write_mail": "Haz clic para escribir un correo",
    "click_top_right": "Haz clic arriba a la derecha en",
    "close": "Cerrar",
    "code_kopieren": "Copiar Código",
    "code_kopieren_success": "Código copiado",
    "confirm_clear_channel_desc": "¿Quieres borrar este canal de tu vista local?",
    "confirm_clear_channel_title": "canal vacio",
    "confirm_clear_chat": "¿Quieres vaciar este chat?",
    "confirm_clear_chat_desc": "¿Quieres vaciar este chat?",
    "confirm_clear_chat_title": "charla vacía",
    "confirm_clear_everyone": "¿Quieres vaciar este chat para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    "confirm_delete_everyone": "¿Quieres borrar este mensaje para ambos? (OK = Para todos, Cancelar = Solo para mí)",
    "confirm_delete_msg": "¿Quieres borrar este mensaje?",
    "confirm_delete_msg_desc": "¿Quieres eliminar este mensaje de chat?",
    "confirm_delete_msg_title": "Eliminar mensaje",
    "confirm_new_password": "Confirmar Nueva Contraseña",
    "copy": "Copiar",
    "create_btn": "Crear",
    "create_channel_title": "Crear canal",
    "create_group_is_crisis": "Marcar como zona de crisis",
    "create_group_title": "Crear nuevo grupo",
    "crypto_lock_desc": "Controla cuándo GaiaCOM elimina las claves criptográficas locales de la memoria.",
    "crypto_lock_menu_desc": "Controla los temporizadores de recarga e inactividad.",
    "crypto_lock_title": "Bloqueo criptográfico",
    "crypto_session_duration": "Desbloqueado después de recargar",
    "crypto_session_duration_desc": "Solo mantiene abierta la sesión criptográfica en esta pestaña del navegador durante el tiempo seleccionado.",
    "cryptographic_fingerprint": "Huella criptográfica",
    "current_password": "Contraseña Actual",
    "data_minimization": "Minimización de datos",
    "decrypt_failed": "No descifrable",
    "delete": "Borrar",
    "delete_account_button": "Eliminar cuenta irrevocablemente",
    "delete_account_confirm_label": "Ingrese BORRAR para confirmar",
    "delete_account_confirmation_error": "Se requiere contraseña y confirmación de BORRAR.",
    "delete_account_desc": "Este modo destruye permanentemente su cuenta, identidades, sesiones de dispositivo, datos de GaiaDrop, metadatos de carga y mensajes atribuibles del lado del servidor.",
    "delete_account_done_desc": "Se han eliminado todos los datos asignables de GaiaCOM.",
    "delete_account_done_title": "Cuenta eliminada",
    "delete_account_menu_desc": "Destruir cuenta y datos asociados.",
    "delete_account_not_authenticated": "Ninguna cuenta activa.",
    "delete_account_title": "Eliminar cuenta",
    "delete_for_everyone": "Eliminar para todos",
    "delete_for_me": "Eliminar solo para mi",
    "device_current": "este dispositivo",
    "device_last_seen": "Último",
    "device_logout": "Finalizar la sesión",
    "device_sessions_desc": "Verifique las sesiones activas y cancele el registro de dispositivos en los que ya no confía.",
    "device_sessions_empty": "No se encontraron dispositivos.",
    "device_sessions_menu_desc": "Administrar y finalizar sesiones activas.",
    "device_sessions_title": "Dispositivos registrados",
    "device_since": "Desde",
    "display_name": "Nombre de Mostrar",
    "drop_address_copied": "Dirección de GaiaDrop copiada.",
    "drop_btn_decrypting": "Descifrando buzón...",
    "drop_btn_load": "Cargar GaiaDrop Inbox",
    "drop_delete_desc": "¿Realmente deseas eliminar permanentemente este drop?",
    "drop_delete_title": "Eliminar GaiaDrop",
    "drop_desc": "Canal de entrega anónimo de texto sin conocimiento previo para pistas externas, revelación responsable e informes confidenciales. Usuarios externos pueden enviar mensajes a tu GaiaID sin cuenta.",
    "drop_empty": "No hay mensajes de GaiaDrop cargados aún.",
    "drop_id": "ID del Drop:",
    "drop_own_address": "Tu dirección de GaiaDrop",
    "drop_proof": "DROP PROOF",
    "drop_title": "Buzón Seguro GaiaDrop",
    "dunkler_modus": " Modo Oscuro",
    "e2e_chat_room_open": "Abrir sala de chat E2E",
    "edit_profile": "Editar Perfil",
    "edit_profile_desc": "Personaliza el nombre para mostrar, la biografía y el avatar.",
    "einladungscode": "Código de Invitación",
    "enter_fingerprint_chars_confirm": "Ingrese los caracteres de huellas digitales solicitados para confirmar.",
    "envelope_hash": "Hash del sobre",
    "erasability": "Eliminabilidad",
    "erfolg": "Éxito",
    "exclude_plaintext": "Exportar sin texto plano",
    "export_disclosure": "Exportar caso de seguridad",
    "export_package_desc": "Solo incluya texto sin formato si esta divulgación es intencional.",
    "export_package_title": "Paquete de seguridad de exportación",
    "fehler": "Error",
    "gaiacom_reader": "Lector GaiaCOM",
    "gaiadrop_inbox_title": "Bandeja de entrada de GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM minimiza los metadatos, mantiene las claves privadas locales, cifra el contenido de un extremo a otro y permite la eliminación completa de la cuenta.",
    "gdpr_home_title": "100% compatible con el RGPD",
    "gdpr_reason_delete": "La eliminación de cuentas elimina cuentas, identidades, sesiones locales y datos asignables del lado del servidor.",
    "gdpr_reason_e2ee": "El contenido privado sigue siendo descifrable sólo para los destinatarios previstos.",
    "gdpr_reason_minimal": "Los metadatos solo se utilizan para credenciales de enrutamiento, entrega y seguridad.",
    "gdpr_reason_zero_knowledge": "Las claves privadas y los datos de recuperación permanecen localmente bajo el control del usuario.",
    "gesendet": "Enviados",
    "gesperrt_verdaechtig": "Bloqueado / Sospechoso",
    "group_delete_desc": "¿Realmente deseas eliminar permanentemente este grupo? Se eliminarán todos los canales y mensajes de este grupo.",
    "group_delete_title": "Eliminar grupo",
    "group_description": "Descripción",
    "group_icon_label": "Icono de grupo/avatar",
    "group_name": "Nombre del grupo",
    "group_settings_avatar": "Avatar",
    "group_settings_desc": "Descripción",
    "group_settings_is_crisis": "Marcar como zona de crisis",
    "group_settings_name": "Nombre de Grupo",
    "group_settings_title": "Configuración de Grupo",
    "groups_empty_desc": "Cree un espacio de trabajo seguro para proyectos, crisis o comunicación de equipo.",
    "groups_empty_title": "Aún no hay chats grupales",
    "gruppe_beitreten": "Grupo Unido",
    "gruppe_erstellen": "+ Crear Grupo",
    "gruppe_verlassen": "Salir del Grupo",
    "gruppen_chats": "Chats de Grupo",
    "heller_modus": " Modo Claro",
    "how_to_receive_drops": "¿Cómo recibo Drops?",
    "identitaets_assistent": "Asistente de Identidad",
    "inactivity_lock_duration": "Bloquear cuando esté inactivo",
    "inactivity_lock_duration_desc": "Después de este período sin entrada, GaiaCOM se bloqueará criptográficamente automáticamente.",
    "inactivity_lock_notice": "GaiaCOM ha sido bloqueado criptográficamente debido a inactividad.",
    "include_plaintext": "Incluir texto sin formato",
    "invite_code_label": "Código de invitación",
    "join_group_title": "Unirse al grupo",
    "kanaele": "Canales",
    "kanal_erstellen": "+ Canal",
    "kein_chat_ausgewaehlt": "Ningún chat seleccionado",
    "kein_kanal_ausgewaehlt": "Ningún canal seleccionado",
    "keine_gruppe_ausgewaehlt": "Ningún grupo seleccionado",
    "keine_mails": "No hay correos disponibles.",
    "key_change_warn_desc": "La clave pública de este contacto ha cambiado. Verifique la huella digital antes de confiar en ella.",
    "key_change_warn_title": "Advertencia criptográfica",
    "key_change_warning_changed": "ha cambiado. ¡Esto puede ser una señal de un ataque de intermediario!",
    "key_change_warning_msg": "La clave de identidad para el contacto",
    "key_transparency": "Transparencia de claves (Historial de claves)",
    "kopiert": "Copiado",
    "kryptographische_schluessel": "Llaves Criptográficas",
    "kryptographische_schluessel_desc": "Muestra claves privadas y frase inicial de respaldo.",
    "laden": "Cargando...",
    "leeren": "Vacío",
    "loading": "Carga...",
    "local_key_vault": "Almacén de claves local",
    "local_keys_label": "Claves locales",
    "lock_on_reload": "Bloquear siempre después de recargar",
    "logout": "Cerrar sesión",
    "mail_compose": "Escribir correo",
    "mein_profil": "Mi Perfil",
    "melden": "Reportar",
    "menu": "Menú",
    "message": "Noticias",
    "message_id": "ID del mensaje",
    "message_pin": "Alfiler",
    "message_pinned_title": "Mensajes fijados",
    "message_react": "Reaccionar",
    "message_reply": "Respuesta",
    "message_replying_to": "Responder a",
    "message_save": "Ahorrar",
    "message_saved": "Guardado",
    "message_to_channel": "Mensaje para",
    "message_unpin": "Resolver",
    "message_unsave": "no guardar",
    "mitglied": "Miembro",
    "mitglieder": "Miembros",
    "ml_kem": "ML-KEM",
    "neue_mail": "Nuevo correo electrónico",
    "never_auto_lock": "Nunca automáticamente",
    "new_fingerprint": "Nueva huella digital",
    "new_identity": "Nueva Identidad",
    "new_password": "Nueva Contraseña",
    "no_description": "Sin descripción",
    "no_key_history": "No hay historial de claves registrado.",
    "no_specification": "Sin especificar",
    "old_fingerprint": "huella digital antigua",
    "open_privacy_imprint": "Impresión abierta y protección de datos",
    "post_quantum_e2e": "E2E Post-Cuántico",
    "posteingang": "Bandeja de entrada",
    "powered_by": "Desarrollado por",
    "privacy_imprint_menu_desc": "Mostrar RGPD, protección de datos y aviso legal.",
    "privacy_imprint_profile_desc": "GaiaCOM procesa el contenido de las comunicaciones de acuerdo con los principios de minimización de datos, cifrado de extremo a extremo y control de claves local.",
    "privacy_imprint_title": "Protección de datos y aviso legal",
    "profil": "Perfil",
    "profile_details": "Detalles del Perfil",
    "profile_settings_hint": "La configuración del perfil se muestra en el panel derecho.",
    "profile_unlock_desc": "Por razones de seguridad, debes ingresar tu contraseña nuevamente para ver tus llaves criptográficas privadas.",
    "proof_hash": "Hash de prueba:",
    "public_drop_desc": "Secure Drop para avisos externos de solo texto sin cuenta GaiaCOM.",
    "public_drop_message": "Mensaje",
    "public_drop_message_placeholder": "Introduzca texto confidencial...",
    "public_drop_send": "Enviar GaiaDrop",
    "public_drop_sender": "Nota opcional del remitente",
    "public_drop_sender_placeholder": "Nombre, número de caso o anónimo",
    "public_drop_target": "GaiaID de destino",
    "quanten_chat": "Chat Cuántico",
    "quantum_secure_exchange": "Intercambio cuántico-seguro a través de...",
    "quantum_secure_net": "Red cuántico-segura GaiaCOM (Ed25519 y ML-KEM)",
    "quantum_shield_desc": "La red GaiaCOM protege su privacidad con un protocolo de cifrado híbrido multicapa seguro contra ataques de futuros ordenadores cuánticos.",
    "quantum_shield_l1_desc": "Utiliza el estándar FIPS 203 para encapsular una clave compartida simétrica. Evita la escucha pasiva y el descifrado posterior (\\\\\\",
    "quantum_shield_l1_title": "1. Protección Post-Cuántica (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Un método de intercambio de claves Diffie-Hellman clásico y ultrarrápido que sirve como capa de seguridad adicional en el esquema híbrido.",
    "quantum_shield_l2_title": "2. Criptografía de Curva Elíptica (X25519)",
    "quantum_shield_l3_desc": "Cada mensaje y sobre de federación está firmado criptográficamente para verificar la autenticidad del remitente fuera de toda duda.",
    "quantum_shield_l3_title": "3. Firmas Digitales (Ed25519)",
    "quantum_shield_l4_desc": "Cifra el contenido del mensaje de forma simétrica y une estrechamente al remitente, destinatario y metadatos en los Datos Adicionales Autenticados (AAD) para evitar ataques de reproducción.",
    "quantum_shield_l4_title": "4. Autenticación AAD (AES-256-GCM)",
    "quantum_shield_status": " Estado del Quantum Shield",
    "receive_drops_step1": "Comparte tu GaiaID (por ejemplo, con el botón copiar de arriba) con fuentes externas.",
    "receive_drops_step2": "Ellos abren la página de inicio de sesión de tu instancia de GaiaCOM, cambian a la pestaña",
    "receive_drops_step3": "y envían su mensaje cifrado a tu dirección allí.",
    "receiver_gaia": "Receptor GaiaCOM",
    "receiver_smtp": "Destinatario SMTP",
    "records_stored": "Registros guardados",
    "refresh": "Actualizar",
    "report_abuse_desc": "¿Quiere denunciar este mensaje y enviar evidencia criptográfica de abuso al servidor?",
    "report_abuse_title": "Informar abuso",
    "reputation_status": "Estado de reputación",
    "room_chat_start_hint": "¡Comienza la conversación! Todos los mensajes en este canal de grupo están cifrados E2E de forma descentralizada y segura contra cuántica.",
    "room_policy_audit": "Seguimiento de auditoría y rotación de claves activa.",
    "room_policy_crisis": "sala de crisis",
    "room_policy_e2ee": "Espacio de conocimiento cero. Caja fuerte cuántica E2EE.",
    "room_policy_title": "Pautas de la habitación",
    "room_policy_zero_knowledge": "Política",
    "room_security_note_desc": "Todos los cambios clave se validan a través de Key Transparency. Utilice GaiaVault para registros de respaldo privados.",
    "room_security_note_title": "Nota de seguridad fijada",
    "save_profile": "Guardar Perfil",
    "schluessel_entsperrt": "🔑 Bloquear llaves de nuevo",
    "search_gaia_label": "Encuentra la dirección de Gaia",
    "security_warning_title": "Advertencia de seguridad",
    "select_channel_chat": "Selecciona un canal de la barra lateral izquierda para chatear.",
    "select_contact_chat": "Selecciona un contacto del panel izquierdo para iniciar un chat E2E seguro cuántico.",
    "select_mail_read": "Selecciona un correo de la lista para leer sus contenidos cuántico-seguros, o crea un mensaje nuevo.",
    "senden": "Enviar",
    "sender_signature": "Firma del remitente",
    "server_log": "Log del servidor:",
    "server_received": "Recibido por el servidor",
    "session_lock": "Bloqueo de sesión",
    "setup_address_keys": "Crear dirección y llaves",
    "setup_profile": "Configurar en el Perfil",
    "smtp_inbox_title": "Recepción SMTP",
    "smtp_legacy_badge": "SMTP heredado/inseguro",
    "smtp_mode_option": "Puente SMTP heredado",
    "smtp_security_warning": "Este correo fue transmitido a través del protocolo clásico SMTP sin cifrar. El cifrado de extremo a extremo no está activo.",
    "smtp_security_warning_desc": "Este mensaje sale de la sala de seguridad de GaiaCom. La entrega SMTP no proporciona garantía nativa de extremo a extremo de GaiaCom, ni garantía TrustMesh ni garantía Godmode desde la puerta de enlace.",
    "spam_verdacht": "Spam/Sospecha",
    "spam_warning_desc": "Este mensaje tiene señales de reputación sospechosas.",
    "spam_warning_title": "Advertencia de spam",
    "speichern": "Guardar",
    "sperren": "Bloquear",
    "standard_group_status": "Chat grupal estándar (cifrado E2EE)",
    "status": "estado",
    "subject": "Acerca de",
    "suchen": "Buscar dirección Gaia...",
    "tage": "Días",
    "time_unknown": "Hora desconocida",
    "transmission_mode": "Modo de transferencia",
    "trust_age": "Edad de confianza",
    "trust_passport_title": "Pasaporte de confianza",
    "unbestaetigt": "No confirmado",
    "unknown_sender": "Desconocido",
    "unlock_btn": "Desbloquear",
    "unlock_btn_profile": "Desbloquear",
    "unlock_desc": "Su archivo de clave privada está almacenado de forma encriptada. Ingrese su contraseña para cargar las claves criptográficas solo en la memoria RAM.",
    "unlock_logout": "Cerrar sesión y cerrar claves locales",
    "unlock_title": "Desbloquear Identidad",
    "untrusted": "No verificado",
    "update_password": "Actualizar Contraseña",
    "upload_avatar_btn": "Subir imagen (Desinfectada)",
    "vault_btn_encrypt": "Encriptar Registro",
    "vault_btn_lock": "Bloquear Caja Fuerte",
    "vault_btn_unlock": "Desbloquear Caja Fuerte",
    "vault_copied_success": "Copiado al portapapeles",
    "vault_decrypted_content": "Contenido descifrado",
    "vault_desc": "Caja fuerte encriptada local para copias de seguridad de recuperación, notas de identidad, credenciales de servidor, contactos de emergencia, notas legales, eventos de seguridad y registros privados.",
    "vault_empty": "No hay registros seguros guardados aún.",
    "vault_locked_pane_notice": "El baúl está bloqueado. Por favor, desbloquéalo a la derecha.",
    "vault_new_record": "Nuevo registro seguro",
    "vault_pwd_placeholder": "Introduce la contraseña de la caja fuerte...",
    "vault_record_body": "Grabar contenido",
    "vault_record_body_placeholder": "Introduce el contenido encriptado del registro...",
    "vault_record_category": "categoría",
    "vault_record_title": "Título del registro",
    "vault_record_title_placeholder": "Título del registro",
    "vault_title": "Caja Fuerte GaiaVault Secure Records",
    "verify_new_fingerprint_hint": "Verifique la nueva huella digital antes de aceptar la clave.",
    "vertrauenswuerdig": "Confiable",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "De",
    "warnung": "Advertencia",
    "wizard_address": "Dirección",
    "wizard_back": "Atrás",
    "wizard_check1": "He guardado de forma segura mi frase semilla.",
    "wizard_custom_domain": "Usar dominio personalizado",
    "wizard_desc1": "GaiaCOM no almacena claves privadas en el servidor. Sin la semilla mnemónica, nadie puede recuperar mensajes perdidos.",
    "wizard_desc2": "Su dirección determina el nodo federado a través del cual se enrutan los sobres cifrados.",
    "wizard_fallback": "Nodos de Respaldo",
    "wizard_finish": "Finalizar Configuración",
    "wizard_next": "Siguiente",
    "wizard_server_domain": "Dominio del nodo del servidor",
    "wizard_step1": "1. Copia de Semilla",
    "wizard_step2": "2. Dirección y Servidor",
    "wizard_title1": "Asegurar Claves de Recuperación",
    "wizard_title2": "Seleccionar Dirección GaiaCOM",
    "write_message_placeholder": "Escribe un mensaje seguro...",
    "you": "Tú",
    "zero_knowledge": "Conocimiento cero",
    "zero_knowledge_encryption": "Cifrado de conocimiento cero",
    "Chat fuer alle geleert": "El chat se ha vaciado para todos los participantes.",
    "Chat geleert": "El chat se ha borrado de tu bandeja de entrada local.",
    "Nachricht fuer alle geloescht": "El mensaje ha sido eliminado para todos los participantes.",
    "Nachricht geloescht": "El mensaje de chat se eliminó localmente de su bandeja de entrada.",
    "anpinnen": "Alfiler",
    "chat_loeschen": "Eliminar chat",
    "confirm_delete_chat_desc": "¿Estás seguro de que deseas eliminar y ocultar el chat?",
    "confirm_leave_group_desc": "¿De verdad quieres dejar este grupo?",
    "entpinnen": "Desprender",
    "group_deleted": "Grupo eliminado exitosamente.",
    "group_left": "Abandona el grupo con éxito.",
    "gruppe_loeschen": "Eliminar grupo",
    "loeschen": "Borrar",
    "no_active_chats": "No hay chats activos. Busque contactos arriba para iniciar un chat.",
    "pinned": "Fijado",
    "wizard_check_credentials": "Soy responsable de mantener seguros mis datos de acceso.",
    "wizard_check_is_beta": "Entiendo que GaiaCom es un software beta.",
    "wizard_check_no_illegal": "No utilizaré GaiaCom con fines ilegales.",
    "wizard_check_no_uptime": "Entiendo que no hay garantía de disponibilidad.",
    "wizard_check_smtp_security": "Entiendo que los mensajes SMTP no brindan seguridad total a GaiaCom.",
    "wizard_check_terms_read": "He leído los Términos de servicio Beta.",
    "wizard_step_terms": "Condiciones de uso",
    "wizard_terms_text": "Términos de uso de GaiaCom y acuerdo de prueba beta (fase beta)\n\nProveedor: VisionGaiaTechnology (en adelante, “Proveedor”)\nEstado: fase de prueba beta pública\nVigencia: A partir del 21 de junio de 2026\n\n⚠️ LA NOTA MÁS IMPORTANTE POR ADELANTADO (LEA ATENTAMENTE)\nGaiaCom se encuentra en una fase de prueba beta pública. A pesar de las amplias medidas de seguridad, no se puede garantizar la ausencia de errores, la disponibilidad continua o la seguridad absoluta del software y de la infraestructura subyacente. Úselo bajo su propio riesgo. Los usuarios son responsables del almacenamiento seguro de sus datos de acceso (especialmente las claves de GaiaVault) y del cumplimiento de las leyes aplicables.\n\n1. Objeto y finalidad de la fase de prueba beta\n1.1. Finalidad de la prestación: GaiaCom es un novedoso servicio de correo electrónico y chat basado en criptografía poscuántica (PQC). La provisión durante la fase beta está destinada exclusivamente a pruebas técnicas, simulación de carga, búsqueda de errores del programa (bugs) y optimización de la facilidad de uso.\n1.2. Estado Beta: El usuario es consciente de que el software ofrecido es una versión preliminar (software beta). Esto aún no está completamente desarrollado técnicamente, no cumple con el estándar de un producto comercial final y puede causar errores, pérdida de datos, retrasos en la transmisión o fallas del sistema.\n1.3. Sin derecho de continuación: El proveedor tiene derecho en cualquier momento a interrumpir total o parcialmente el servicio, a cambiar o restringir funciones o a eliminarlas temporal o definitivamente sin necesidad de indicar los motivos.\n\n2. Disponibilidad y exención de responsabilidad de garantía\n2.1. Sin garantía de disponibilidad: GaiaCom se proporciona sin ninguna garantía de disponibilidad o tiempo de actividad. No existe ningún derecho a la disponibilidad ininterrumpida del servicio.\n2.2. Exclusión de garantía: El software se proporciona en su estado actual (“tal cual”) y sujeto a disponibilidad. En la medida en que lo permita la ley, quedan excluidos todos los derechos de garantía por defectos materiales y legales del software. En particular, no hay garantía de que el software esté libre de errores, de malware o de que sea adecuado para un propósito particular.\n\n3. Gestión de riesgos y obligaciones de los usuarios\n3.1. Prohibición de almacenamiento de datos críticos: El usuario se compromete a no almacenar ni transmitir exclusivamente a través de GaiaCom ningún dato crítico para el negocio, vital, operativamente necesario o legalmente particularmente sensible (como archivos de pacientes, datos financieros altamente sensibles o secretos regulados oficialmente). El servicio no se puede utilizar para infraestructura donde fallas imprevistas podrían provocar lesiones personales, daños a la propiedad o pérdidas financieras significativas.\n3.2. Copia de seguridad autorresponsable: El usuario es responsable de realizar una copia de seguridad de todos los datos recibidos o enviados a través de GaiaCom que necesite a largo plazo en sus propios sistemas independientes (copias de seguridad). El proveedor no garantiza el almacenamiento permanente ni la capacidad de restauración de los datos en sus servidores.\n\n4. Funciones criptográficas y GaiaVault\n4.1. Criptografía poscuántica (PQC): GaiaCom implementa procesos de cifrado de última generación orientados al futuro y diseñados para resistir ataques de futuras computadoras cuánticas. Sin embargo, el usuario es consciente de que se trata de un campo científico dinámico y nuevo. No se puede garantizar una seguridad absoluta e irrefutable basándose en el estado actual de la ciencia y la tecnología. Términos como “100% seguro”, “indescifrable” o “militarmente seguro” no están garantizados expresamente.\n4.2. Sin garantía de recuperación (GaiaVault): GaiaCom se basa en un concepto de seguridad consistente de conocimiento cero. Las cuñas de cifrado y los datos de acceso permanecen únicamente bajo el control del usuario (protegidos a través de GaiaVault).\nIMPORTANTE: Si el usuario pierde sus contraseñas, frases de contraseña, claves privadas o semillas de recuperación, el proveedor no tiene capacidad técnica para reconstruir o restablecer estos datos. La pérdida de estos datos de acceso conduce inevitablemente a la pérdida irrevocable del acceso a la cuenta de usuario y a todos los datos cifrados en ella.\n4.3. Aún no completamente auditado: el software está sujeto continuamente a controles de seguridad internos, pero en el momento de esta fase beta aún no se ha sometido a una auditoría de seguridad externa completa y final por parte de organismos de prueba independientes.\n\n5. Interfaces, protocolos heredados y federación\n5.1. Nota sobre el puente SMTP: GaiaCom ofrece la posibilidad de comunicarse a través de protocolos de correo electrónico clásicos (como SMTP). El usuario es consciente de que los mensajes que salen del área de seguridad nativa de GaiaCom (por ejemplo, cuando se envían a una dirección convencional @gmail.com o @gmx.de) se transportan a través de servidores no cifrados o de terceros. Las garantías de seguridad de extremo a extremo de GaiaCom se aplican solo de forma limitada o no se aplican en absoluto a dichos mensajes heredados salientes o entrantes externos.\n5.2. Nota sobre la federación: si GaiaCom opera en una red federada, los mensajes y los datos pueden pasar a través de servidores de terceros. Si bien el contenido de los mensajes permanece protegido mediante cifrado de extremo a extremo, los metadatos (como la hora de envío, las direcciones IP de los servidores involucrados y las direcciones de los destinatarios) pueden ser técnicamente visibles para los operadores de estos servidores federados. El proveedor no tiene influencia sobre las prácticas de protección de datos de terceros operadores de servidores en la red federada.\n\n6. Usos Aceptables y Actividades Prohibidas\nEl usuario se compromete a no utilizar el servicio de forma indebida o con fines ilícitos. En particular, quedan prohibidos:\n- Distribuir, enviar o alojar virus, malware, contenido de phishing u otro software malicioso.\n- Usar el Servicio para realizar ataques de denegación de servicio (DDoS) o envíos masivos de correo no solicitado (spam).\n- Abusar del sistema para cometer fraude.\n- La distribución o intercambio de contenido ilegal, en particular representaciones de abuso sexual infantil (CSAM), propaganda terrorista, llamados a la violencia u otro contenido criminalmente relevante.\n\n7. Sistema de denuncia de abusos\n7.1. Denunciar comportamientos abusivos: los usuarios tienen la oportunidad de denunciar comunicaciones abusivas o actividades ilegales a través del sistema de abuso integrado.\n7.2. Procesamiento de informes: para garantizar la protección contra el uso indebido, los informes entrantes se pueden analizar técnicamente (manteniendo los límites de privacidad y cifrado). Esto puede dar lugar a la suspensión temporal o permanente de cuentas de usuario o direcciones IP en caso de violaciones comprobadas de estos términos de uso.\n\n8. Limitación de responsabilidad\n8.1. Estándar de responsabilidad: El software beta se proporciona de forma gratuita. Por lo tanto, según las normas legales sobre donaciones o préstamos, el proveedor sólo es responsable de dolo (daño intencionado) y negligencia grave.\n8.2. Exclusión de responsabilidad por pérdida de datos: Se excluye la responsabilidad por la pérdida de datos a menos que la pérdida haya sido causada intencionalmente o por negligencia grave por parte del proveedor y el usuario haya cumplido con su obligación de mitigar el daño mediante copias de seguridad periódicas (fuera de GaiaCom).\n8.3. Límites legales: Las limitaciones de responsabilidad anteriores no se aplican a lesiones a la vida, el cuerpo o la salud ni a la responsabilidad según la Ley de Responsabilidad del Producto.\n\n9. Código abierto\nCiertos componentes, bibliotecas o aplicaciones cliente de GaiaCom pueden tener licencias de código abierto (por ejemplo, GPL, MIT, Apache). Los términos de licencia respectivos de estos componentes no se ven afectados por estos términos de uso y pueden verse en los repositorios de código fuente correspondientes.\n\n10. Control y cumplimiento de las exportaciones\nEl usuario es consciente de que el software criptográfico puede estar sujeto a estrictos controles de exportación y restricciones legales. El usuario es responsable de garantizar que el uso de GaiaCom no viole las leyes, restricciones de importación/exportación o regulaciones de criptografía de su respectivo país de residencia.\n\n11. Aviso de protección de datos (versión corta para la beta)\n11.1. Recopilación mínima de datos: como parte de la fase beta, el proveedor solo recopila los datos que son absolutamente necesarios para el funcionamiento técnico, la resolución de problemas y el desarrollo posterior (por ejemplo, archivos de registro del servidor para el diagnóstico de errores).\n11.2. Sin información sobre el contenido: gracias al constante conocimiento cero y al cifrado E2E, el proveedor nunca tiene acceso al contenido de sus chats, correos electrónicos o claves almacenadas en GaiaVault.\n11.3. Declaración detallada de protección de datos: Las normas detalladas de protección de datos están vinculadas por separado y también deben ser tenidas en cuenta por el usuario antes de registrarse.\n\n12. Disposiciones finales\n12.1. Ley aplicable: Se aplica la ley de la República Federal de Alemania, excluyendo la Convención de las Naciones Unidas sobre los Contratos de Compraventa Internacional de Mercaderías.\n12.2. Sujeto a cambios: Dado que GaiaCom se encuentra en desarrollo activo, el proveedor se reserva el derecho de adaptar estas condiciones en cualquier momento con efecto para el futuro. La versión actual está disponible en la aplicación.",
    "wizard_terms_title": "Términos de uso de GaiaCom y acuerdo de prueba beta (fase beta)",
    "node_operator": "Operador de nodo",
    "search_channels": "Buscar canales...",
    "senior_reviewer": "Revisor sénior",
    "trusted_reviewer": "Revisor confiable",
    "active_frequencies": "Frecuencias activas",
    "connected_rooms": "ESPACIOS CONECTADOS",
    "dashboard": "Panel",
    "empty_chats": "No hay chats activos disponibles.",
    "empty_messages": "No hay mensajes nuevos disponibles.",
    "encrypted": "cifrado",
    "gaiacom_uplink": "ENLACE ARRIBA GAIACOM",
    "install_app": "Instalar aplicación",
    "install_app_desc": "Para inicio rápido y modo fuera de línea",
    "kommandozentrale_alpha": "Centro de mando ALFA",
    "network_online": "RED: EN LÍNEA",
    "new_room": "Nuevo espacio",
    "no_frequencies_active": "No hay frecuencias activas. Crea una nueva sala para iniciar la comunicación.",
    "no_id": "Sin identificación",
    "open_chats": "abrir chats",
    "open_inbox": "Abrir bandeja de entrada",
    "primary_identity": "IDENTIDAD PRIMARIA",
    "recent_chats": "Nuevos chats",
    "recent_messages": "Últimas noticias",
    "session_encrypted": "Sesión cifrada: {nombre}",
    "session_secure": "ESTADO: SEGURO",
    "system_verlassen": "Sistema de salida",
    "write_message": "Escribe un mensaje",
    "onboarding_step_profile": "Perfil",
    "onboarding_step_security": "Protección",
    "onboarding_step_backup": "Respaldo",
    "onboarding_step_launch": "Comenzar",
    "onboarding_loading_gaia_id": "Cargando Gaia-ID",
    "onboarding_setup_kicker": "Configuración Inicial de GaiaCom",
    "onboarding_profile_title": "Haz de GaiaCom tu espacio.",
    "onboarding_profile_desc": "Tu nombre de pantalla y avatar se controlan localmente y pueden cambiarse en el perfil en cualquier momento.",
    "onboarding_security_title": "Lo que GaiaCom protege por ti ahora mismo.",
    "onboarding_security_desc": "GaiaCom separa identidad, claves, mensajes y estado de red. Aquí solo ves la versión corta del usuario.",
    "onboarding_backup_title": "Un respaldo es tu verdadera salida de emergencia.",
    "onboarding_backup_desc": "Sin datos de recuperación, nadie puede rescatar tu identidad. Ese es exactamente el propósito de la seguridad de extremo a extremo real.",
    "onboarding_launch_title": "¿Listo? ¿Qué quieres hacer primero?",
    "onboarding_launch_desc": "Puedes empezar de inmediato o finalizar el recorrido y continuar trabajando en el panel.",
    "onboarding_display_name": "Nombre de pantalla",
    "onboarding_display_name_placeholder": "¿Cómo quieres que te muestre GaiaCom?",
    "onboarding_select_avatar": "Seleccionar avatar",
    "onboarding_sec_identity_title": "Identidad",
    "onboarding_sec_identity_desc": "Tu Gaia-ID es tu ancla de red. Los contactos pueden detectar cambios de claves.",
    "onboarding_sec_messages_title": "Mensajes",
    "onboarding_sec_messages_desc": "El contenido se descifra localmente. Los mensajes editados reciben nuevas firmas.",
    "onboarding_sec_network_title": "Red",
    "onboarding_sec_network_desc": "El Centro de Seguridad y el Centro de Denuncias visibilizan riesgos sin puertas traseras globales.",
    "onboarding_sec_transparency_title": "Transparencia",
    "onboarding_sec_transparency_desc": "Registra eventos de seguridad en el protocolo para que las advertencias sean rastreables.",
    "onboarding_backup_notice_title": "Importante para usuarios comunes",
    "onboarding_backup_notice_desc": "Guarda tus datos de recuperación separados de este dispositivo. Si pierdes la contraseña y el respaldo, GaiaCom permanecerá bloqueado a propósito.",
    "onboarding_backup_consent": "Sé que mi respaldo es crucial para la recuperación y el cambio de dispositivo.",
    "onboarding_inbox_title": "Bandeja de entrada",
    "onboarding_inbox_desc": "Leer correos y redactar tu primer mensaje.",
    "onboarding_contacts_title": "Contactos",
    "onboarding_contacts_desc": "Verificar el primer contacto o iniciar un chat.",
    "onboarding_channels_title": "Canales",
    "onboarding_channels_desc": "Descubrir frecuencias públicas.",
    "onboarding_security_title_card": "Centro de Seguridad",
    "onboarding_security_desc_card": "Ver el estado de GaiaShield.",
    "onboarding_later": "Más tarde",
    "onboarding_back": "Atrás",
    "onboarding_continue": "Continuar",
    "onboarding_complete_setup": "Completar configuración",
    "auth_legal_consent": "He leído y acepto la política de privacidad y los términos de uso.",
    "auth_show_terms": "Mostrar términos de uso",
    "auth_recovery_mode": "Modo de recuperación",
    "auth_recovery_import_title": "Importar archivo de recuperación",
    "auth_recovery_import_desc": "Restaure sus claves de GaiaCom desde un archivo de respaldo protegido por contraseña. Después, el mnemónico y el nombre de usuario se completarán automáticamente.",
    "auth_recovery_file_pwd_placeholder": "Contraseña del archivo de recuperación",
    "auth_recovery_local_pwd_placeholder": "Nueva contraseña de desbloqueo local mín. 12 caracteres",
    "auth_recovery_importing": "Importando...",
    "auth_recovery_decrypt": "Descifrar recuperación",
    "auth_back_to_login": "Volver al inicio de sesión",
    "auth_terms_title": "Términos de uso de GaiaCom Beta",
    "auth_terms_close": "Cerrar",
    "auth_cookie_title": "GaiaCOM sigue siendo soberano.",
    "auth_cookie_desc": "Solo utilizamos almacenamiento local técnicamente necesario para el idioma, la sesión y la seguridad. Sin seguimiento, sin cookies publicitarias, sin perfiles de terceros.",
    "auth_cookie_accept": "Entendido",
    "sc_explainer_title": "¿Qué se protege realmente aquí?",
    "sc_explainer_desc": "GaiaShield es la capa protectora entre tu cuenta, tus mensajes y la red. No decide sobre contenidos, sino sobre riesgos técnicos: manipulación, intentos de reproducción, acceso no autorizado, patrones de inicio de sesión sospechosos y transiciones inseguras de puertas de enlace.",
    "sc_explainer_identity_desc": "Comprueba anomalías de inicio de sesión, riesgos de sesión y acceso a otras identidades.",
    "sc_explainer_messages_desc": "Detecta patrones de reproducción, sobres manipulados y falta de funciones de integridad.",
    "sc_explainer_network_desc": "Marca riesgos de federación, límite de velocidad y SMTP antes de que se muestre una confianza incorrecta.",
    "sc_open_security_warnings": "Advertencias de seguridad abiertas",
    "sc_opt_all": "Todos",
    "sc_opt_low": "Bajo",
    "sc_opt_medium": "Medio",
    "sc_opt_high": "Alto",
    "sc_opt_critical": "Crítico",
    "sc_opt_failed_login": "Inicio fallido",
    "sc_opt_auth_attack": "Ataque de autenticación",
    "sc_opt_rate_limit": "Límite de tarifa",
    "sc_opt_policy_violation": "Advertencia de directiva",
    "sc_opt_message_replay": "Reproducción de mensaje",
    "sc_node_security_data_unavailable": "Datos de seguridad del nodo no disponibles",
    "sc_total_events": "Eventos totales",
    "sc_login_attacks": "Ataques de inicio de sesión",
    "sc_rate_limits_active": "Límites de tarifa activos",
    "sc_smtp_shield_hits": "Impactos de SMTP Shield",
    "sc_top_event_categories": "Principales categorías de eventos",
    "sc_no_entries": "Sin entradas.",
    "sc_node_audit_log": "Registro de auditoría del nodo (recientes)",
    "sc_no_node_events": "Sin eventos de nodo.",
    "archiv": "Archivo",
    "entwuerfe": "Borradores",
    "markiert": "Destacados",
    "wichtig": "Importantes",
    "snoozed": "Pospuestos",
    "papierkorb": "Papelera",
    "spam": "Spam",
    "cancel": "Cancelar",
    "error": "Error",
    "success": "Éxito",
    "kopieren": "Copiar",
    "block_contact": "Bloquear contacto",
    "unblock_contact": "Desbloquear contacto",
    "report_contact": "Reportar contacto",
    "check_fingerprint": "Verificar huella digital",
    "export_encrypted": "Exportar (Cifrado)",
    "export_gaiaproof": "Exportar (GaiaProof)",
    "export_password_prompt": "Ingrese una contraseña para cifrar la exportación del chat:",
    "export_success": "Chat exportado y cifrado correctamente.",
    "export_failed": "Exportación fallida: ",
    "gaiaproof_export_success": "Paquete GaiaProof exportado correctamente.",
    "gaiaproof_export_failed": "Exportación de GaiaProof fallida: ",
    "export_gaiaproof_confirm": "¿Desea descargar el paquete GaiaProof con todas las firmas y recibos de entrega del servidor? Esto puede tardar un momento.",
    "group_settings_is_private": "Sala privada (no buscable públicamente, solo solicitudes de unión)",
    "group_settings_read_only": "Modo de solo lectura (solo el propietario y los administradores pueden enviar mensajes)",
    "group_settings_slow_mode": "Modo lento (cooldown de envío)",
    "gsn_title": "Feed social GSN",
    "gsn_node_feed": "Feed del nodo",
    "gsn_following_feed": "Siguiendo",
    "gsn_feed_empty": "No se encontraron publicaciones.",
    "gsn_composer_placeholder": "¿Qué hay de nuevo en la federación?",
    "gsn_post_btn": "Compartir",
    "gsn_profile": "Perfil de usuario",
    "gsn_followers": "Seguidores",
    "gsn_following": "Siguiendo",
    "gsn_bio": "Descripción / Bio:",
    "gsn_bio_label": "Descripción / Bio",
    "gsn_display_name": "Nombre para mostrar",
    "gsn_edit_profile": "Editar perfil",
    "gsn_save_profile": "Guardar",
    "gsn_add_image": "Agregar imagen (Cifrado)",
    "gsn_add_emoji": "Insertar emoji",
    "gsn_avatar_emoji": "Avatar (Emoji)",
    "gsn_follow": "Seguir",
    "gsn_unfollow": "Dejar de seguir",
    "gsn_repost": "Compartir / Repostear",
    "gsn_post_created": "Publicación compartida correctamente.",
    "gsn_image_uploaded": "Imagen cifrada y cargada.",
    "gsn_upload_failed": "Carga de imagen fallida: ",
    "gsn_comment_placeholder": "Escribe un comentario...",
    "gsn_delete_confirm_title": "¿Eliminar publicación?",
    "gsn_delete_confirm_desc": "¿Está seguro de que desea eliminar permanentemente esta publicación?",
    "gsn_delete_comment_confirm_title": "¿Eliminar comentario?",
    "gsn_delete_comment_confirm_desc": "¿Está seguro de que desea eliminar permanentemente este comentario?",
    "gsn_report": "Reportar",
    "gsn_report_title": "Reportar infracción",
    "gsn_report_category": "Categoría",
    "gsn_report_spam": "Spam / Publicidad",
    "gsn_report_harassment": "Acoso / Discurso de odio",
    "gsn_report_abuse": "Abuso",
    "gsn_report_illegal": "Contenido ilegal",
    "gsn_report_severity": "Gravedad",
    "gsn_report_low": "Bajo",
    "gsn_report_medium": "Medio",
    "gsn_report_high": "Alto",
    "gsn_report_comment": "Comentario adicional",
    "gsn_report_submit": "Reportar",
    "gsn_report_submitted": "El reporte ha sido enviado a gobernanza.",
    "gsn_report_post": "Reportar publicación",
    "report_group": "Reportar grupo",
    "report_group_reason_prompt": "Ingrese una razón para el reporte (opcional):",
    "report_reason_prompt": "Ingrese una razón para el reporte (opcional):",
    "report_failed": "Error al reportar: ",
    "report_success": "Contacto reportado correctamente.",
    "room_read_only_placeholder": "Solo el propietario y los administradores pueden escribir",
    "read_only_active": "Modo de solo lectura",
    "slow_mode_active": "Modo lento activo",
    "kommandozentrale": "Centro de mando",
    "kontakt_blockiert": "Contacto bloqueado",
    "kontakt_freigegeben": "Contacto desbloqueado",
    "mailbox_settings_title": "Configuración del buzón",
    "mailbox_settings_desc": "Administrar firma, idioma, filtros de correo.",
    "mic_access_denied": "Acceso al micrófono denegado: ",
    "no_frequencies_active_desc": "Cree una nueva sala para comenzar a comunicarse.",
    "key_changed_warning_title": "AVISO DE SEGURIDAD:",
    "key_changed_warning_desc": "La clave de identidad de este remitente se ha actualizado o difiere de la clave conocida anteriormente. Verifique la huella digital a través de otro canal seguro.",
    "sc_col_category": "Categoría",
    "search_members": "Buscar miembros...",
    "tab_general": "General",
    "tab_members": "Miembros",
    "tab_requests": "Solicitudes",
    "tab_invites": "Invitaciones",
    "tab_logs": "Registros",
    "auth_why_gaiacom": "¿Por qué GaiaCOM?",
    "auth_why_gaiacom_desc": "La alternativa segura y descentralizada para su comunicación confidencial.",
    "auth_self_managed_id": "ID autogestionada",
    "auth_self_managed_id_desc": "Cree instantáneamente identidades criptográficas seguras sin proporcionar correo electrónico o teléfono.",
    "auth_gaiadrop_secure_exchange": "Intercambio seguro sin cuenta",
    "auth_gaiadrop_benefit_e2ee": "Cifrado de extremo a extremo",
    "auth_gaiadrop_benefit_no_login": "No se requiere inicio de sesión",
    "auth_gaiadrop_benefit_inbox": "Entrega directa en la bandeja de entrada del destinatario",
    "auth_terms_of_use": "Condiciones de uso",
    "auth_terms_of_use_show": "Mostrar condiciones de uso",
    "auth_consent_privacy_terms": "He leído y acepto la política de privacidad y las condiciones de uso.",
    "auth_recovery_import_file": "Importar archivo de recuperación",
    "auth_recovery_password": "Contraseña del archivo de recuperación",
    "auth_recovery_local_password": "Nueva contraseña de desbloqueo local mín. 12 caracteres",
    "auth_recovery_decrypting": "Descifrando recuperación...",
    "auth_recovery_back": "Volver al inicio de sesión",
    "auth_cookie_sovereign": "GaiaCOM sigue siendo soberano.",
    "auth_cookie_sovereign_desc": "Solo utilizamos funciones de almacenamiento local técnicamente necesarias para el idioma, la sesión y la seguridad. Sin seguimiento, sin cookies publicitarias, sin perfiles de terceros.",
    "auth_cookie_sovereign_accept": "Entendido",
    "unlock_keyboard_toggle": "⌨️ Usar teclado",
    "unlock_keypad_toggle": "🔢 Usar teclado PIN",
    "unlock_status_denied": "ACCESO DENEGADO / REINTENTAR",
    "unlock_status_decrypting": "DESCIFRANDO TRESOR...",
    "unlock_status_secured": "TRESOR ASEGURADO / BLOQUEADO",
    "auth_landing_nav_legal": "Avisos Legales",
    "auth_landing_nav_beta": "Prueba Beta",
    "auth_landing_card1_title": "Criptografía Post-Cuántica (ML-KEM)",
    "auth_landing_card2_title": "100% Descentralizado",
    "auth_landing_card3_title": "Conocimiento Cero",
    "auth_landing_card4_title": "Protección de Metadatos",
    "auth_landing_card5_title": "Identidad Autogestionada",
    "auth_landing_hybrid_title": "Criptografía de hoy más protección para el mañana.",
    "auth_landing_hybrid_desc": "GaiaCom combina el intercambio de claves clásico probado con el encapsulado de claves post-cuántico. Sin elecciones ciegas: defensa en profundidad.",
    "auth_landing_x25519_desc": "Intercambio de claves de curva elíptica rápido y probado para dispositivos actuales y sesiones seguras.",
    "auth_landing_mlkem_desc": "Encapsulado de claves post-cuántico para confidencialidad a largo plazo contra escenarios de descifrado posterior.",
    "auth_landing_cycle_title": "El servidor no ve nada. La red solo transporta ruido.",
    "auth_landing_step1_title": "Cifrado Local",
    "auth_landing_step1_desc": "El mensaje se cifra en el dispositivo del remitente, antes de llegar a la red o al servidor.",
    "auth_landing_step2_title": "Transporte como Blob",
    "auth_landing_step2_desc": "El paquete viaja como ruido criptográfico a través de nodos federados o capas de almacenamiento descentralizadas.",
    "auth_landing_step3_title": "Almacenamiento Federado",
    "auth_landing_step3_desc": "Sin buzón central como objetivo. Los datos están fragmentados, federados o descentralizados y completamente cifrados.",
    "auth_landing_step4_title": "Descifrado Local",
    "auth_landing_step4_desc": "Solo la clave privada del destinatario puede convertir el blob de nuevo en contenido legible.",
    "auth_landing_trinity_title": "Un concepto de protocolo. Tres niveles de infraestructura.",
    "auth_landing_enterprise_desc": "Para corporaciones, firmas de abogados, medianas empresas, industria y banca privada. Círculos cerrados con control administrativo, cumplimiento y soporte.",
    "auth_landing_enterprise_list1": "Soberanía interna y administración de usuarios",
    "auth_landing_enterprise_list2": "Nodo autoalojado o clúster soberano gestionado",
    "auth_landing_enterprise_list3": "SLA, soporte y módulos premium",
    "auth_landing_network_desc": "La red abierta para la privacidad digital. Sin comercio de datos, sino infraestructura para comunicación libre y cifrada.",
    "auth_landing_network_list1": "Cliente de código abierto",
    "auth_landing_network_list2": "Nodos federados",
    "auth_landing_network_list3": "Sin claves centrales de descifrado",
    "auth_landing_defend_desc": "Infraestructura de alta seguridad especializada para autoridades, infraestructuras críticas y silos de comunicación aislados.",
    "auth_landing_defend_list1": "Despliegues en entornos aislados y desconectados",
    "auth_landing_defend_list2": "Marca blanca y auditoría de código fuente",
    "auth_landing_defend_list3": "Soberanía digital nacional",
    "auth_landing_gov_title": "Protocolo abierto. Ejecución comercial. Separación jurídica clara.",
    "auth_landing_gov_desc": "GaiaCom separa el protocolo abierto, los clientes abiertos y la infraestructura premium comercial. La confianza proviene de la transparencia; los ingresos, de operaciones empresariales, soporte, integraciones y módulos especiales.",
    "auth_landing_price1_desc": "Tasa de protección contra bots para distribución en AppStore/PlayStore.",
    "auth_landing_price2_desc": "Código abierto para usuarios que prefieren compilarlo ellos mismos.",
    "auth_landing_price3_desc": "Para medianas empresas, firmas de abogados y equipos sensibles.",
    "auth_landing_price4_desc": "Para corporaciones, clústeres de alta disponibilidad, LDAP y acceso raíz.",
    "auth_landing_license1_desc": "Máxima transparencia para usuarios, bifurcaciones y auditorías de la comunidad.",
    "auth_landing_license2_desc": "Protección copyleft contra robo en la nube y bifurcaciones de protocolo cerradas.",
    "auth_landing_license3_desc": "LDAP, acceso raíz, auditoría, SLA y lógica de negocio especializada.",
    "auth_landing_final_title": "Comunicación según el modelo de confianza cero.",
    "auth_landing_final_desc": "GaiaCom no reemplaza simplemente el correo electrónico. Plantea la pregunta de por qué la comunicación confidencial hoy en día sigue basándose en buzones centrales, servidores legibles y suposiciones de hace 40 años.",
    "auth_landing_final_note": "Nota: Esta página describe una visión arquitectónica y hoja de ruta. Las promesas de seguridad deben confirmarse mediante implementación, auditorías y pruebas reales antes de su despliegue productivo."




  };

export default es;